import { render, staticRenderFns } from "./OrganizationUsers.vue?vue&type=template&id=55f5bc3d&"
import script from "./OrganizationUsers.vue?vue&type=script&lang=js&"
export * from "./OrganizationUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports